import { CtaButton } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledButtonWrapperProps } from './BookingInformationButton.types';

export const StyledButtonWrapper = styled.div<IStyledButtonWrapperProps>`
  display: flex;
  justify-content: ${({ flexProperty }) => flexProperty};
`;

export const StyledButton = styled(CtaButton)`
  cursor: pointer;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    &:not(:first-child) {
      margin-left: ${rem('0px')};
    }
  }
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem('10px')};
`;
